document.addEventListener('DOMContentLoaded', function () {
	window.dataLayer = window.dataLayer || [];

	if (document.getElementById('hmWordpressBlockPlayer')) {
		videojs('hmWordpressBlockPlayer').ready(function () {
			let myPlayer = this;
			let playEventLogged = false;

			myPlayer.on('playing', function () {
				let isAudio = document.querySelector(
					'.wp-block-hm-brightcove-with-tracking.video__id.is-audio',
				);
				let playerEvent = isAudio ? 'audio_start' : 'video_start';

				if (!playEventLogged) {
					const videoTitle = myPlayer.mediainfo.name;
					const playerId = myPlayer.bcinfo.playerId;
					const videoId = myPlayer.mediainfo.id;

					window.dataLayer.push({
						event: playerEvent,
						videoTitle: videoTitle,
						playerId: playerId,
						videoId: videoId,
					});
					playEventLogged = true;
				}
			});
		});
	}
});
